import React from 'react';
import { Link } from 'react-router-dom';

const BestServicesBlock = (props) => {	  	
    return(
	<>
	{/* <!-- OUR BEST SERVICES SECTION  START --> */}                  
	<div className="section-full text-center p-t80 p-b50 bg-gray">
		<div className="container">
		
			{/* <!-- TITLE START --> */}
			<div className="section-head">
				<h3 className="text-uppercase">Our Facility</h3>
				<div className="wt-separator style-icon">
					<i className="fa fa-leaf text-black"></i>
					<span className="separator-left site-bg-primary"></span>
					<span className="separator-right site-bg-primary"></span>
				</div>  
			</div>
			{/* <!-- TITLE END --> */}
			
			{/* <!-- OUR BEST SERVICES BLOCKS START --> */}
			<div className="section-content">
				<div className="row">
			
				{/* <!-- COLUMNS 1 --> */}
				<div className="col-lg-4 col-md-6 col-sm-6 m-b30 animate_line">
					<div className="wt-icon-box-wraper  p-a30 center bg-white m-a5">
						<div className="icon-md site-text-primary m-b20">
							<Link to="/services-detail" className="icon-cell"><i className="flaticon-envelope" aria-hidden="true"></i></Link>
						</div>
						<div className="icon-content">
							<h5 className="wt-tilte text-uppercase">Classrooms</h5>
							<p>The fundamental spaces for teaching and learning, potentially specialized for different subjects.</p>
						</div>
					</div>
				</div>
				{/* <!-- COLUMNS 2 --> */}
				<div className="col-lg-4 col-md-6 col-sm-6 m-b30 animate_line">
					<div className="wt-icon-box-wraper  p-a30 center bg-white m-a5">
						<div className="icon-md site-text-primary m-b20">
							<Link to="/services-detail" className="icon-cell"><i className="flaticon-envelope"></i></Link>
						</div>
						<div className="icon-content ">
							<h5 className="wt-tilte text-uppercase">Laboratories</h5>
							<p>Equipped for scientific experiments and practical learning in subjects like science and computer science.</p>
						</div>
					</div>
				</div>
				{/* <!-- COLUMNS 3 --> */}
				<div className="col-lg-4 col-md-6 col-sm-6 m-b30 animate_line">
					<div className="wt-icon-box-wraper  p-a30 center bg-white m-a5">
						<div className="icon-md site-text-primary m-b20">
							<Link to="/services-detail" className="icon-cell"><i className="flaticon-envelope"></i></Link>
						</div>
						<div className="icon-content">
							<h5 className="wt-tilte text-uppercase">Libraries</h5>
							<p>Provide access to a wide range of academic resources and learning materials. Lot of books are vailable.</p>
						</div>
					</div>
				</div>
				{/* <!-- COLUMNS 4 --> */}
				<div className="col-lg-4 col-md-6 col-sm-6 m-b30 animate_line">
					<div className="wt-icon-box-wraper  p-a30 center bg-white m-a5">
						<div className="icon-md site-text-primary m-b20">
							<Link to="/services-detail" className="icon-cell"><i className="flaticon-envelope"></i></Link>
						</div>
						<div className="icon-content">
							<h5 className="wt-tilte text-uppercase">Sports Facilities</h5>
							<p>Playgrounds, gyms, and other areas for physical activities and extracurricular development.</p>
						</div>
					</div>
				</div>
				{/* <!-- COLUMNS 5 --> */}
				<div className="col-lg-4 col-md-6 col-sm-6 m-b30 animate_line">
					<div className="wt-icon-box-wraper  p-a30 center bg-white m-a5">
						<div className="icon-md site-text-primary m-b20">
							<Link to="/services-detail" className="icon-cell"><i className="flaticon-envelope"></i></Link>
						</div>
						<div className="icon-content">
							<h5 className="wt-tilte text-uppercase">Safety Measures</h5>
							<p>Including security systems, fire safety equipment, and emergency procedures. CCTV Camera's are available.</p>
						</div>
					</div>
				</div>
				{/* <!-- COLUMNS 6 --> */}
				<div className="col-lg-4 col-md-6 col-sm-6 m-b30 animate_line">
					<div className="wt-icon-box-wraper  p-a30 center bg-white m-a5">
						<div className="icon-md site-text-primary m-b20">
							<Link to="/services-detail" className="icon-cell"><i className="flaticon-envelope"></i></Link>
						</div>
						<div className="icon-content">
							<h5 className="wt-tilte text-uppercase">Sanitation and Hygiene</h5>
							<p>Clean and well-maintained toilets, drinking water facilities, and proper ventilation are essential. </p>
						</div>
					</div>
				</div>
				
			</div>
			</div>
			{/* <!-- OUR BEST SERVICES BLOCKS END --> */}
			
		</div>
	</div>
	{/* <!-- OUR BEST SERVICES SECTION END --> */}
    </>
    )
}
export default BestServicesBlock;